import { IClassDTOIn } from '../interfaces/groups/class.interface';

export const mockClasses: IClassDTOIn[] = [
    {
        id: 2001,
        education_level_id: 2,
        name: 'class 1',
        is_active: true,
        class_type_id: 1,
        school_year_id: 1,
        schedules: [
            { id: 1, day: 'monday', start_time: '08:30', end_time: '16:30' },
            { id: 2, day: 'tuesday', start_time: '08:30', end_time: '16:30' },
            { id: 3, day: 'wednesday', start_time: '08:30', end_time: '12:30' },
            { id: 4, day: 'thursday', start_time: '08:30', end_time: '16:30' },
            { id: 5, day: 'friday', start_time: '08:30', end_time: '16:30' },
        ],

        teacher_ids: [1, 2],
        supervisor_ids: [1],
        student_ids: [3],
        school_id: 1000,
        titular_ids: [1, 2],
    },
];
